import { Layer } from '../core/layer';
import metadata from './preset/__metadata';

const layerStorage: Record<string, Layer> = {};
const cdnStorage: Record<string, boolean> = {};
const promiseStorage: Map<string, Promise<boolean>> = new Map();

function isLink(url: string) {
  const linkRegex = /^(https?:\/\/)(cdn\.)?[\w-]+(\.[\w-]+)+(:\d+)?(\/[^\s]*)?$/i;
  return linkRegex.test(url);
}

function checkCDN(url: string) {
  return !!cdnStorage[url];
}

function validateViewType(layer: Layer) {
  if (
    !layer.isNormalLayer &&
    !layer.isStandardChartLayer &&
    !layer.isHXKLineLayer &&
    !layer.isExternalLayer
  ) {
    console.error('缺少视图类型定义');
  }
}

export async function loadScriptFromLayer(layer: Layer) {
  if (!layer?.cdn) {
    return;
  }
  const cdnArray = Array.isArray(layer.cdn) ? layer.cdn : [layer.cdn];
  const loadPromises = cdnArray.map(url => {
    if (!isLink(url) || checkCDN(url)) {
      return Promise.resolve(false);
    }
    if (promiseStorage.has(url)) {
      return promiseStorage.get(url);
    }

    const scriptPromise = new Promise<boolean>((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.onload = () => {
        cdnStorage[url] = true;
        resolve(true);
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });

    promiseStorage.set(url, scriptPromise);

    return scriptPromise;
  });
  await Promise.all(loadPromises);
}

export function registerLayer(layer: Layer) {
  validateViewType(layer);
  if (!layer.visInfo.standers) {
    // eslint-disable-next-line no-param-reassign
    layer.visInfo.standers = 'f10';
  }

  const itemMetadata = (metadata as any)[layer.visInfo.name_zh];

  if (!itemMetadata) {
    console.warn(`[${layer.visInfo.name_zh}] missing meta information.`);
  } else {
    /* eslint-disable */
    layer.visInfo.purpose_zh = itemMetadata.purpose_zh;
    layer.visInfo.purpose_en = itemMetadata.purpose_en;
    layer.visInfo.types_en = itemMetadata.types_en;
    // @ts-ignore
    layer.visInfo.types = itemMetadata.types_en;
    // @ts-ignore
    layer.visInfo.purposes = itemMetadata.purpose_en;
    /* eslint-enable */
  }

  layerStorage[layer.type] = layer;
}

export function hasLayer(type: string): boolean {
  return !!layerStorage[type];
}

export function getLayer(type: string): Layer {
  if (!hasLayer(type)) {
    throw Error(`组件库中没有注册类型为${type}的layer定义`);
  }
  return layerStorage[type];
}
